export default "__VITE_ASSET__DCwPv5zb__"